var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4493 22H0V0H25.4493V22ZM0.558098 21.4416H24.8912V0.558376H0.558098V21.4416Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08788 0.268066H6.52979V21.7097H7.08788V0.268066Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3833 0.290283H12.8252V21.7319H13.3833V0.290283Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3994 0.290283H18.8413V21.7319H19.3994V0.290283Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1258 5.68433H0.346191V6.2427H25.1258V5.68433Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1033 10.866H0.32373V11.4243H25.1033V10.866Z",
    fill: "#233A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1033 15.7576H0.32373V16.3159H25.1033V15.7576Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43);
export default __webpack_public_path__ + "static/media/Group43.542d81094bce6960cd931c56b1de7e26.svg";
export { ForwardRef as ReactComponent };